import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => createStyles({
  customersRoot: {
    display: 'flex',
    flex: '1 1 auto',
    marginBottom: theme.spacing(2),
    cursor: 'pointer'
  },
  customersCard: {
    display: 'flex',
    flex: '1 1 auto',
    marginBottom: theme.spacing(2),
    cursor: 'pointer'
  },
  skeleton: {
    display: 'flex',
    flex: '1 1 auto',
    marginBottom: theme.spacing(2),
    cursor: 'pointer'
  },
  icon: {
    fontSize: 70,
    margin: theme.spacing(2)
  },
  box: {
    textAlign: 'left',
    margin: theme.spacing(2)
  },
  customerNumberBox: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5)
  },
  chevron: {
    margin: theme.spacing('auto', 2, 'auto', 'auto')
  },
  breakAllText: {
    wordBreak: 'break-all'
  }
}));